import { Component, OnInit, OnDestroy} from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { VersionCheck } from './shared/services/version-check.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{
  title = 'Angular-Salesrep';
  constructor(
    public router: Router,
    private versionCheck: VersionCheck){
}

ngOnInit() {
   this.router.events.subscribe((event) =>{
    try{
      if (event instanceof NavigationStart){
        this.versionCheck.initVersionCheckForComponent(environment.versionCheckURL)
     }
     }catch(e){
       console.log(e)
     }
   });
  }
}
